import { useState } from "react";
import { Reveal } from "./Reveal";
import { Phone, ExternalLink, Loader2, Lock } from "lucide-react";
import { PHONE, PHONE_HREF, FORM_URL, IMAGES } from "../../lib/erg";

export const IntakeForm = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <section
      id="intake"
      data-testid="intake-section"
      className="relative py-24 sm:py-32 scroll-mt-16"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14 items-start">
          <Reveal className="lg:sticky lg:top-24">
            <span className="font-mono text-[12px] tracking-[0.22em] uppercase text-erg-ember">
              Dry land
            </span>
            <h2 className="mt-4 font-display font-bold uppercase text-erg-ink leading-[0.95] text-[clamp(2.1rem,6vw,4rem)]">
              You've made it.<br />Let's get started.
            </h2>
            <p className="mt-6 text-erg-ink/75 text-lg leading-relaxed text-pretty">
              This is our work authorization form — light verification, your name matched
              to the property address. It takes a couple of minutes, and it's what lets our
              crew move.
            </p>

            <div className="mt-7 flex items-center gap-2.5 text-erg-ink/60">
              <Lock className="h-4 w-4" />
              <span className="font-mono text-[12px] tracking-wide">
                Submitted directly and securely to our intake team.
              </span>
            </div>

            <div className="mt-8 rounded-2xl overflow-hidden border border-erg-ink/10">
              <img src={IMAGES.dryRoom} alt="A calm, dry home in warm morning light" className="w-full h-40 object-cover" />
            </div>

            <a
              data-testid="intake-phone-link"
              href={PHONE_HREF}
              className="mt-6 inline-flex items-center gap-2 text-erg-ink font-medium hover:text-erg-ember transition-colors duration-300"
            >
              <Phone className="h-4 w-4" />
              Prefer to talk? Call or text {PHONE}
            </a>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-erg-ink/10 bg-white shadow-[0_30px_80px_-40px_rgba(20,27,34,0.5)] overflow-hidden">
              <div className="flex items-center justify-between px-5 py-3.5 border-b border-erg-ink/10 bg-erg-dry">
                <span className="font-display font-semibold uppercase tracking-wide text-erg-ink text-sm">
                  ERG Work Authorization
                </span>
                <a
                  data-testid="intake-open-newtab"
                  href={FORM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 font-mono text-[11px] text-erg-mid hover:text-erg-ember transition-colors"
                >
                  Open in new tab <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </div>

              <div className="relative bg-white">
                {!loaded && (
                  <div className="absolute inset-0 grid place-items-center bg-white z-10">
                    <div className="flex flex-col items-center gap-3 text-erg-ink/50">
                      <Loader2 className="h-6 w-6 animate-spin" />
                      <span className="font-mono text-xs tracking-wide">Loading secure form…</span>
                    </div>
                  </div>
                )}
                <iframe
                  data-testid="intake-iframe"
                  title="ERG Work Authorization Form"
                  src={FORM_URL}
                  onLoad={() => setLoaded(true)}
                  className="w-full h-[820px] sm:h-[760px]"
                  loading="lazy"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
